import { ISignInBody } from '../../types';

export const INITIAL_VALUES: ISignInBody = {
  email: '',
  password: '',
};
